<template>
   <div
      v-for="(product, index) in products"
      :key="product.id"
      class="group relative bg-white border-r border-b border-gray-200 pt-6 flex flex-col md:grid grid-cols-12 overflow-hidden item transition-opacity duration-200 w-full"
   >
      <div class="col-span-12 flex flex-col md:grid grid-cols-12">
         <div class="col-span-3 order-2 md:order-1">
            <div class="md:pb-12">
               <Link
                  class="block"
                  :href="product.url"
                  :title="product.name"
                  v-if="(scrolled && index > 3) || index < 4"
               >
                  <VuePicture
                     :width="250"
                     :height="250"
                     :image="product.image"
                     :name="product.name"
                     :style="'mx-auto'"
                     :notlazy="index == 0"
                  />
               </Link>
               <div
                  v-if="product.colors.length > 1"
                  class="flex justify-center mb-4"
               >
                  <div
                     v-for="color in product.colors"
                     :key="color.id"
                     class="space-x-3"
                  >
                     <span v-html="color.html"></span>
                  </div>
               </div>

               <!-- Compare -->
            </div>

            <label
               :for="'compare' + product.id"
               class="flex items-center w-fit select-none z-10 py-4 pl-4 absolute bottom-0 left-0"
               v-if="category.comparable"
            >
               <div :class="comparison && Object.values(comparison).length == 5 && !product.compared ? 'opacity-50 relative' : ''">
                  <div
                     class="absolute inset-0 h-full w-full z-20 group"
                     v-if="comparison && Object.values(comparison).length == 5"
                  >
                     <span class="tippy">U kunt max 5 producten vergelijken</span>
                  </div>
                  <input
                     :disabled="comparison && Object.values(comparison).length == 5 && !product.compared"
                     :name="'compare' + product.id"
                     :id="'compare' + product.id"
                     v-model="product.compared"
                     @input="addToComparison(product.slug)"
                     type="checkbox"
                     class="h-5 w-5 border-gray-300 rounded text-blue-600 transition focus:ring-0 hover:border-gray-600"
                  />
                  <div
                     :for="'compare' + product.id"
                     class="pl-2 inline-block"
                  >
                     Vergelijk dit product
                  </div>
               </div>
            </label>
         </div>

         <div class="col-span-5 px-6 md:px-0 order-1 md:order-2 md:pr-4">
            <!-- Name -->
            <Link
               class="block"
               :href="product.url"
               :title="product.name"
            >
               <h2 class="pr-16 font-semibold">{{ product.name }}</h2>
            </Link>

            <!-- Level -->
            <p
               class="text-gray-500 text-sm"
               v-if="product.rating_value == 1"
            >
               Goed beveiligd
            </p>
            <p
               class="text-gray-500 text-sm"
               v-if="product.rating_value == 2"
            >
               Zwaar beveiligd
            </p>
            <p
               class="text-gray-500 text-sm"
               v-if="product.rating_value == 3"
            >
               Extra zwaar beveiligd
            </p>

            <!-- Reviews -->
            <div
               class="flex items-center mt-2"
               v-if="product.reviews.count && ((scrolled && index > 3) || index < 4)"
            >
               <review-stars
                  :score="product.reviews.score"
                  height="h-3"
               />
               <Link
                  class="ml-2 text-sm text-gray-600 link"
                  :href="product.url + '#product-reviews'"
                  >{{ product.reviews.score }}/5 ({{ product.reviews.count }} {{ $t('beoordelingen') }})</Link
               >
            </div>

            <!-- Compare -->
            <table class="w-full compare mt-4">
               <tbody>
                  <product-specs-value
                     v-for="(option, index) in product.attributes"
                     :key="option.id"
                     :option="option"
                     :class="{ '': index % 2 === 0, 'bg-gray-50': index % 2 !== 0 }"
                  />
               </tbody>
            </table>
         </div>
         <div class="col-span-4 pr-4 px-6 md:pl-0 order-3 pb-10 md:pb-0">
            <!-- <Link :href="product.url">
                    <span aria-hidden="true" class="absolute inset-0" />
                </Link> -->
            <img
               :src="asset('img/skg-' + product.skg + '.png')"
               v-if="product.skg"
               :alt="'SKG' + product.skg + ' keurmerk'"
               width="40"
               height="30"
               class="absolute right-4 md:inset-0 top-4 md:relative w-10 mb-4"
            />

            <date
               class="text-sm"
               :date="product.date"
               :pickup="product.delivery_days == 1 ? product.firstPickupDate : false"
               v-if="(scrolled && index > 3) || index < 4"
            />

            <div
               class="bg-gray-50 rounded p-3 space-y-1 text-sm"
               v-if="product.cylinder_prices.length && wizardCompleted"
            >
               <table class="table-auto w-full pricing">
                  <tbody>
                     <tr
                        v-for="(cylinder, index) in product.cylinder_prices"
                        :key="index"
                        class="relative"
                     >
                        <td align="left">{{ cylinder.size }} - {{ cylinder.name }}</td>
                        <td align="right">
                           <span class="">{{ price(cylinder.price) }}</span>
                        </td>
                        <div
                           v-if="product.cylinder_prices.length > 1"
                           class="w-4 absolute left-1/2 -translate-x-3 border-r border-gray-400"
                           :class="[
                              index == 0 ? 'h-3 bottom-0 border-t' : '',
                              index == product.cylinder_prices.length - 1 ? 'top-0 h-3 border-b' : '',
                              index != 0 && index != product.cylinder_prices.length - 1 ? 'h-full' : '',
                           ]"
                        >
                           <div
                              v-if="index != 0 && index != product.cylinder_prices.length - 1"
                              class="w-4 absolute top-1/2 border-b border-gray-400"
                              :class="{
                                 'w-6':
                                    index + 1 == product.cylinder_prices.length / 2 ||
                                    index + 1 == product.cylinder_prices.length / 2 + 0.5,
                              }"
                           ></div>
                           <div
                              class="absolute ml-7"
                              v-if="
                                 index + 1 == product.cylinder_prices.length / 2 || index + 1 == product.cylinder_prices.length / 2 + 0.5
                              "
                           >
                              Gelijksluitend
                           </div>
                        </div>
                     </tr>
                     <tr v-if="product.keys_extra">
                        <td>{{ product.keys_extra.title }}</td>
                        <td align="right">
                           <span class="">{{ price(product.keys_extra.price) }}</span>
                        </td>
                     </tr>
                     <tr v-else>
                        <td>{{ product.keys }} sleutels</td>
                        <td align="right">
                           <span class="text-green-600">Gratis</span>
                        </td>
                     </tr>
                     <tr v-if="product.cylinder_prices.length">
                        <td>Totaal incl. BTW</td>
                        <td align="right">
                           <strong>{{ price(product.price) }}</strong>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>

            <!-- Sale -->
            <Link
               v-if="$appStore.settings.sale_enabled && product.discount"
               :href="product.url"
               class="bg-black text-white rounded px-3 py-1 w-full mt-2 items-center flex shadow-red-700/20 shadow-overallxs border border-red-700 hover:shadow-red-700/40 transition-all"
            >
               <fa
                  :icon="['fas', 'fa-star']"
                  class="h-3 w-3 mr-3 text-red-700"
               />
               <strong class="grow text-white"> {{ product.discount.value }}% korting </strong>
               <span class="float-right">
                  <span
                     class="text-sm"
                     v-if="category.id == 1 || category.catalog_id == 1"
                     >v.a.</span
                  >
                  <s class="mx-2">{{ price(product.price) }}</s>
                  <strong> {{ price(product.price - product.price * (product.discount.value / 100)) }}</strong></span
               >
            </Link>

            <Link
               v-else-if="product.discount"
               :href="product.url"
            >
               <!-- <fa :icon="['fas', 'fa-star']" class="h-3 w-3 mr-3 text-red-700" /> -->
               <strong class="grow text-green-700"> {{ product.discount.value }}% korting </strong>
               <span class="float-right">
                  <span
                     class="text-sm"
                     v-if="category.id == 1 || category.catalog_id == 1"
                     >v.a.</span
                  >
                  <s class="mx-2">{{ price(product.price) }}</s>
                  <strong> {{ price(product.price - product.price * (product.discount.value / 100)) }}</strong></span
               >
            </Link>

            <div
               v-else-if="!product.cylinder_prices.length || !wizardCompleted"
               class="text-xl mb-4"
            >
               <span
                  class="text-sm text-gray-600 mr-2"
                  v-if="category.id == 1 || category.catalog_id == 1"
                  >v.a.</span
               ><strong>{{ price(product.price) }}</strong>
            </div>

            <div class="flex my-4">
               <Link
                  :href="product.url"
                  class="button green w-full"
                  >{{ category.id == 1 || category.catalog_id == 1 ? 'Set samenstellen' : 'Bekijk product' }}</Link
               >

               <span
                  @click="addToCart(product)"
                  class="button semi-green z-10 cursor-pointer flex ml-2 items-center"
                  v-if="filtered && (category.id == 1 || category.catalog_id == 1) && wizardCompleted && wizardUsed"
               >
                  <fa
                     :icon="['fad', 'spinner-third']"
                     class="opacity-80 mr-2 fa-spin"
                     v-if="product.loading"
                  />
                  <fa
                     v-else
                     :icon="['fal', 'plus']"
                     class="mr-2"
                  />
                  <fa
                     :icon="['fal', 'shopping-cart']"
                     class="h-5 w-5"
                  />
               </span>
            </div>
         </div>
         <div
            class="rounded-r-md absolute left-0 top-0 mt-72 md:mt-8 text-white text-sm bg-dgreen px-3 py-1"
            v-if="product.featured"
         >
            Aanbevolen
         </div>
      </div>
   </div>
</template>

<script setup>
import ProductSpecsValue from '@/Components/LevelValue.vue'
import { router, useForm, usePage } from '@inertiajs/vue3'
import { computed, onMounted, ref } from 'vue'
const inBrowser = typeof window !== 'undefined'
const props = defineProps({
   products: Array,
   category: Object,
   filtered: Boolean,
   wizardUsed: Boolean,
})
const scrolled = ref(false)

onMounted(function () {
   if (inBrowser) {
      window.addEventListener('scroll', function () {
         if (window.scrollY > 100 && !scrolled.value) {
            scrolled.value = true
         }
      })

      window.mitt.on('comparisonRemove', function (value) {
         // Remove product from comparison list
         Object.values(props.products).forEach((product) => {
            if (product.id == value) {
               product.compared = false
            }
         })
      })
   }
})

const form = useForm({})
const wizardCompleted = computed(() => usePage().props.wizardCompleted)
const comparison = computed(() => usePage().props.comparisonList)
const gtag = computed(() => usePage().props.flash.gtag)

function addToCart(product) {
   product.loading = true

   router.post(
      '/cart/category/' + product.id,
      {},
      {
         onSuccess() {
            product.loading = false
            window.mitt.emit('openCartSlide', true)
            let parsedGtag = JSON.parse(JSON.stringify(gtag.value))
            dataLayer.push({ ecommerce: null })
            dataLayer.push(parsedGtag)
         },
      }
   )
}

// Disable product.compared checkbox if removed from comparisonList

function addToComparison(slug) {
   form.post('/comparison/add/' + slug, {
      only: ['comparisonList'],
      preserveScroll: true,
      preserveState: true,
      onSuccess() {
         // Show summary! And animate :)
      },
   })
}
</script>

<style>
.compare tbody td {
   border-bottom: 0px !important;
   padding-top: 0.3rem !important;
   padding-left: 0.3rem !important;
   padding-bottom: 0.3rem !important;
}

.pricing tbody td {
   border-bottom: 0px !important;
   padding-top: 0.05rem !important;
   padding-bottom: 0.05rem !important;
}
</style>
